import { Component, Input, OnInit, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { Store } from "@ngrx/store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogActions
} from "@angular/material/dialog";
import { AvailabilityCodeStore } from "@app/services/store/availability-code-store";
import { AvailabilityCode } from "@app/models/rest/availability-code";
import { AvailabilityType } from "@app/models/enums/availability-type.enum";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-availability-code-add",
  templateUrl: "./availability-code-add.component.html",
  styleUrls: ["./availability-code-add.component.scss"],
  imports: [
    MatDialogTitle,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class AvailabilityCodeAddComponent implements OnInit {
  availabilityCodeStore = inject(AvailabilityCodeStore);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<AvailabilityCodeAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  availabilityCodeForm = new UntypedFormGroup({
    AvailabilityCodeDescription: new UntypedFormControl(
      "",
      Validators.required
    ),
    AvailabilityType: new UntypedFormControl("", Validators.required)
  });

  @Input()
  availabilityCode: AvailabilityCode;

  // retryLoad() {
  //   super.retry(this.priorityStore);
  // }

  ngOnInit() {
    this.availabilityCodeStore.entity.subscribe((availabilityCode) => {
      this.availabilityCode = availabilityCode;
    });
  }

  getErrorMessage(controlName: string) {
    console.log(this.availabilityCodeForm.controls[controlName].errors);
    console.log("get error");
    return this.availabilityCodeForm.controls[controlName].errors.server;
  }

  onCancelButton() {
    this.dialogRef.close();
  }

  addAvailabilityCode() {
    const availabilityCode: AvailabilityCode = new AvailabilityCode();
    availabilityCode.description =
      this.availabilityCodeForm.controls["AvailabilityCodeDescription"].value;

    switch (this.availabilityCodeForm.controls["AvailabilityType"].value) {
      case "ASSIGN":
        availabilityCode.availabilityType = AvailabilityType.ASSIGN;
        break;
      case "BLOCK":
        availabilityCode.availabilityType = AvailabilityType.BLOCK;
        break;
      case "EXTEND":
        availabilityCode.availabilityType = AvailabilityType.EXTEND;
        break;
    }

    this.availabilityCodeStore.create(availabilityCode).subscribe(
      (value) => {
        this.ngOnInit();
        console.log("success");
        this.dialogRef.close({ success: true });
      },
      (error) => {
        console.log("error");
        console.log(error);
        // alert(error.error.message)
      }
    );
  }
}
